export const updateOrgName = async (service, body) => {
  return service.put(`/org/profile`, body);
};
